import { IconProps } from '@/root/shared-types/ui/ui-types'
import React, { FC } from 'react'
import Icon from '@/root/ui/shared/Icon'

export const CartIcon: FC<IconProps> = ({ width = 32, height = 32, ...rest }) => (
  <Icon type="Cart" width={width} height={height} alt="Cart" {...rest} />
)
